<template>
  <Fieldset
    apply
    :title="title"
    :subtitle="subtitle"
    :columns="columns"
  >
    <slot />
    <template
      v-if="hasInfo"
      slot="action"
    >
      <Tooltip :content="information" />
    </template>
  </Fieldset>
</template>

<script>
import { Fieldset, Tooltip } from '@dunia/ui';

export default {
  name: 'UiDuniaBaseFieldset',
  components: {
    Fieldset,
    Tooltip,
  },
  props: {
    isInvalid: {
      type: Boolean,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    columns: {
      type: String,
    },
    information: {
      type: String,
    },
  },
  computed: {
    hasInfo() {
      return !!this.information;
    },
  },
};
</script>

<style>

</style>
